<template>
  <div>
    <modal-campos-nao-preenchido v-if="modalCamposNaoPreenchidos" v-model="modalCamposNaoPreenchidos" :camposNaoPreenchidos="camposNaoPreenchidos" @modalCamposNaoPreenchidoAcaoFechar="fecharModalCamposNaoPreenchidos" />
    <v-form @submit.prevent="atualizarLicitacao">
      <div class="az-form-content">
        <v-container fluid grid-list-xl>
          <dados-gerais v-if="licitacaoCarregada" v-model="licitacaoAtualizacao"
                        :exibirAno="exibirAno" @atualizar="atualizarLicitacao" :acao="acao"/>
          <div class="az-actions-form">
            <div class="align-left"></div>
            <div class="align-right" v-if="editando && isEditavel">
              <a class="action-primary" @click="atualizarLicitacao">Salvar</a>
            </div>
          </div>
        </v-container>
      </div>
    </v-form>
  </div>

</template>

<script>
    import {mapActions, mapState} from 'vuex'
    import DadosGerais from '../commons/DadosGerais'
    import {actionTypes} from '@/commons/constants'
    import validadorDatas from './licitacao-atualizacao-validador-datas'
    import _ from "lodash";
    import ModalCamposNaoPreenchido from '@/commons/components/ModalCamposNaoPreenchido.vue'

    export default {
        components: {ModalCamposNaoPreenchido, DadosGerais},
        data() {
            return {
                editando: false,
                alterandoDados: false,
                licitacaoAtualizacao: {},
                licitacaoCarregada: false,
                modalCamposNaoPreenchidos: false,
                camposNaoPreenchidos: []
            }
        },
        computed: {
            isEditavel(){
              return !this.licitacao.publicado || !this.licitacao.executarLicitacao || this.alterandoDados
            },
            acao() {
                if (this.alterandoDados) {
                    return 'alterando-dados'
                }
                if (this.editando) {
                    return 'editando'
                }
                return 'visualizando'
            },
            exibirAno() {
                return this.parametros.propriedadesLicitacao.exibirAno
            },
            ...mapState(['licitacao','parametros'])
        },
        async mounted() {
            this.editando = this.$route.query.edicao
            this.$root.$on('alterarDadosLicitacao', this.habilitarAlteracaoDados)
            await this.buscarLicitacao(this.$route.params.id)
            this.licitacaoCarregada = true
            await this.atribuirLicitacao()
        },
        beforeDestroy() {
          this.$root.$off('alterarDadosLicitacao', this.habilitarAlteracaoDados)
        },
        methods: {
            habilitarAlteracaoDados() {
              this.alterandoDados = true
            },
            async atribuirLicitacao(){
              this.licitacaoAtualizacao = _.cloneDeep(this.licitacao)
            },
            async atualizarLicitacao() {
                if(!this.licitacao.usuarioComissao){
                  this.mostrarNotificacaoErro('Usuario não faz parte da comissão.')
                  return
                }
                this.validarAmparoLegal()
                const validarBeneficioRegionalLocal = this.validarBeneficioRegional()
                if(!validarBeneficioRegionalLocal){
                  this.mostrarNotificacaoErro('Informe os municípios.')
                  return
                }
                const existeCamposNaoPreenchidos = await this.validarCamposNaoPreenchidos()
                if(existeCamposNaoPreenchidos){
                  return
                }
                const datasValidadas = validadorDatas.validar(this.licitacaoAtualizacao)
                if (!datasValidadas.valido) {
                    this.mostrarNotificacaoErro(datasValidadas.mensagem)
                    return
                }
                this.setMensagemLoading('Atualizando a licitação...')
                await this.$store.dispatch(actionTypes.ATUALIZAR_LICITACAO, {
                    licitacaoId: this.licitacaoAtualizacao.id,
                    licitacao: this.licitacaoAtualizacao,
                    atualizarSistemasExternos: this.alterandoDados
                })
                await this.buscarLicitacao(this.licitacao.id)
                await this.atribuirLicitacao()
                this.alterandoDados = false
                this.mostrarNotificacaoSucessoDefault()
            },
            validarAmparoLegal(){
              if(this.licitacaoAtualizacao.amparoLegal && !this.licitacaoAtualizacao.amparoLegal.id){
                this.licitacaoAtualizacao.amparoLegal = null
              } else if(this.licitacaoAtualizacao.amparoLegal){
                this.licitacaoAtualizacao.idAmparoLegal = this.licitacaoAtualizacao.amparoLegal.id
                this.licitacaoAtualizacao.amparoLegal = {
                    id: this.licitacaoAtualizacao.amparoLegal.id
                }
              }
            },
            validarBeneficioRegional(){
              if(this.licitacaoAtualizacao.beneficiosRegionais.length === 0 && this.licitacaoAtualizacao.beneficioRegional){
                 return false
              }
              return true
            },
            async validarCamposNaoPreenchidos() {

                await this.$validator._base.validateAll()

                this.camposNaoPreenchidos = this._validarCamposObrigatoriosLicitacaoAtualizacao(this.licitacaoAtualizacao)

                this.modalCamposNaoPreenchidos = this.camposNaoPreenchidos.length > 0

                return this.camposNaoPreenchidos.length > 0
          },
          fecharModalCamposNaoPreenchidos(){
            this.modalCamposNaoPreenchidos = false
          },
            ...mapActions([actionTypes.BUSCAR_LICITACAO, actionTypes.BUSCAR_QTD_PROPOSTAS_POR_LICITACAO])
        },
        watch: {
          'licitacao.publicado': {
            async handler() {
              await this.atribuirLicitacao()
            }
          }
        }
    }
</script>
